
P3Portal.Filters = (function() {
    var parent = false;
    var table = false;
    // declare private variables and/or functions    
    
    var searchvalues = [], filtervalues = {}, filtertypes = [];

    var getSortVal = function(){
      var val = $('#content-sort select').val();
      
    }
    
    //
    var search = function(){
      // Which column should we search on
      // We're going to build some basics here
      var searchfield = $('th[data-filter="search"]', table).index()+1,
          i = 0, length = 0
          searchval = $('#content-search input').val(),
          filtervals = {},
          sortval = $('#content-sort select').val();
          
      $('td:nth-child('+searchfield+')', table).each(function(){
        $(this).parent().attr('index', i).addClass('searchable search-'+i);
        searchvalues.push($(this).text().toLowerCase().trim());
        i++;
      });
      
      // bind the search listner
      $('#content-search input').keyup(function(){
        var val = $(this).val().toLowerCase().trim();
        searchval = val;
        doSearchSort(searchval, filtervals, sortval);
      });
      
      // now get all of the filter values
      var types = {}, filtercol;
      $('.filter-tool').each(function(){
        var type = $(this).attr('data-type'), i = 0;
        filtervals[type] = $('select', $(this)).val();
        filtertypes.push(type);
        filtercol = $('th[data-filter="'+type+'"]', table).index()+1;

        if(filtercol){
          // only add the filter if the type exists
          types[type] = [];
          $('td:nth-child('+filtercol+')', table).each(function(){
            // eventually expand this to do better filtering based other values rather than string
            $(this).parent().addClass('filterable filter-'+i);
            types[type].push($(this).text().toLowerCase().trim());
            i++;
          });
        }
      });
      filtervalues = types;
      
      $('.filter-tool select').change(function(){
        var val = $(this).val().toLowerCase(), filterlen = val.length,
          filtertype = $(this).parent().parent().attr('data-type');
          filtervals[filtertype] = val;
          doSearchSort(searchval, filtervals, sortval);
      });
      
      $('.sort-tool select').change(function(){
        sortval = $('#content-sort select').val()
        doSearchSort(searchval, filtervals, sortval);
      });

      doSearchSort(searchval, filtervals, sortval);
    };
    
    
    var doSearchSort = function(search, filter, sort){
      var i = 0, length = searchvalues.length,
          numberOfTypes = filtertypes.length, t = 0, show;
          
      // Itterate over the search values as the default
      for(i; i < length; i++){
        show = true; // assume we show it
        // is the search set and does it match
        if(search){ // we only do this work if the search is set
          if(searchvalues[i]){
            if(searchvalues[i].indexOf(search) < 0){
              show = false; // excluded
            }
          }
        }
        
        t = 0; // reset t
        if(filter && show){ // we only do this work if we are showing it still and a filter is set
          for(t; t < numberOfTypes; t++){
            var ft = filtertypes[t];

            if(filtervalues[ft] && filter[ft]){ // confirm that the type exists
              if(filter[ft] != 'all'){
                if(filtervalues[ft][i].indexOf(filter[ft]) < 0){
                  show = false; // excluded
                }
              }
            }
          }
        }

        if(show){
          $('.search-'+i).show();
        }else{
          $('.search-'+i).hide();
        }
      }
      
      var multiplex = 1, parts;
      if(sort.indexOf('_') > 0){
        parts = sort.split('_');
        sort = parts[0];
        if(parts[1] == 'asc') multiplex = -1;
      }
      var aval, bval, 
        headIndex = $('th[data-sort="'+sort+'"').index()+1;
      
      $('tbody tr', table).sortElements(function(a, b){
        // get the column we are sorting on
        aval = $('td:nth-child('+headIndex+')', $(a)).text().toLowerCase().trim();
        bval = $('td:nth-child('+headIndex+')', $(b)).text().toLowerCase().trim();
        if ( aval < bval )
          return -1 * multiplex;
        if ( aval > bval )
          return 1 * multiplex;
        return 0;
      });
    }

    
    var view = function(){
      $('#list-view').click(function(e){
        e.preventDefault();
        table.removeClass('grid');
        $(this).addClass('active');
      });
      $('#gallery-view').click(function(e){
        e.preventDefault();
        table.addClass('grid');
        $(this).addClass('active');
      });
    };

    return {
      // declare public variables and/or functions
      init: function(){
        var search_open = false;
        var stored_open = window.localStorage.getItem('p3.search');

        if(stored_open == 'true'){
          search_open = true;
          $('#content-filters').removeClass('collapsed');
        }
        $('#search-action').click(function(e){
          e.preventDefault();
          $('#content-filters').toggleClass('collapsed');
          if(search_open == 'true'){
            search_open = false;
            window.localStorage.removeItem('p3.search');
          }else{
            search_open = true;
            window.localStorage.setItem('p3.search', true);
          }
        });

        
        parent = $('#content-filters');
        table = $('table.sort');
        console.log(table);
        if(parent.length > 0){
          var clientside = parent.attr('data-clientside');
          console.log(clientside);
          if(clientside !== 'false'){
            search();
            view();
          }
            
        }
      }
    };
    
})();


P3Portal.Filters.init();
